module.exports = require("eventemitter3");


//////////////////
// WEBPACK FOOTER
// external "eventemitter3"
// module id = 3
// module chunks = 0